import React from 'react';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';

import {
  Container,
  ItemsWrapper,
  SelectLabel,
  TotalLabel,
  PaginationWrapper,
  PaginationLabel,
  ButtonsWrapper,
  Button,
  SelectWrapper,
  StyledSelect,
  ChevronIcon,
} from './styles';

type PaginationProps = {
  currentPage: number;
  totalPages: number;
  totalPerPage: number;
  handleTotalPerPage: (total: number) => void;
  handleSetPage: (page: number) => void;
  nextPage: () => void;
  prevPage: () => void;
};

const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalPages,
  totalPerPage,
  handleSetPage,
  handleTotalPerPage,
  nextPage,
  prevPage,
}) => {
  return (
    <Container>
      <ItemsWrapper>
        <SelectLabel>Itens por página:</SelectLabel>
        <SelectWrapper>
          <StyledSelect
            onChange={(e) => handleTotalPerPage(Number(e.target.value))}
            value={totalPerPage}
          >
            <option>10</option>
            <option>20</option>
            <option>30</option>
            <option>40</option>
            <option>50</option>
          </StyledSelect>
          <ChevronIcon size={20} />
        </SelectWrapper>
        <TotalLabel>
          {`1 - ${totalPerPage} de ${Number(totalPages) * totalPerPage} itens`}
        </TotalLabel>
      </ItemsWrapper>
      <PaginationWrapper>
        <SelectWrapper>
          <StyledSelect
            value={currentPage}
            onChange={(e) => handleSetPage(Number(e.target.value))}
          >
            {Number(totalPages) > 0 &&
              [...Array(Number(totalPages))].map((_, index) => {
                const pageNumber = index + 1;
                return (
                  <option key={pageNumber} value={pageNumber}>
                    {pageNumber}
                  </option>
                );
              })}
          </StyledSelect>
          <ChevronIcon size={20} />
        </SelectWrapper>
        <PaginationLabel>
          {`de ${totalPages} ${Number(totalPages) > 1 ? 'páginas' : 'página'}`}
        </PaginationLabel>
        <ButtonsWrapper>
          <Button onClick={prevPage} disabled={currentPage === 1}>
            <FiChevronLeft size={22} color="#b1b1b1" />
          </Button>
          <Button
            onClick={nextPage}
            disabled={currentPage >= Number(totalPages)}
          >
            <FiChevronRight size={22} color="#b1b1b1" />
          </Button>
        </ButtonsWrapper>
      </PaginationWrapper>
    </Container>
  );
};

export default Pagination;
